export const page_builder_origin = process.env.REACT_APP_PG_BUILDER_ENDPOINT;
